module.exports = __webpack_public_path__ + "static/media/passportToken.4c549e96.svg";